import { useCallback, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { debounce } from "lodash";
import TableLayoutV2 from "components/TableLayoutV2";
import { Breadcrumbs, CstmPagination } from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ErrorComponent from "components/shared/ErrorComponent";
import { userFullName } from "helpers/common";
import { useGetNotificationManagementUsersQuery } from "store/services/notifications";
import { MANAGE_NOTIFICATIONS } from "config/paths";

const categoryLabel = (category) => category.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
const userName = (user) => userFullName(user) || user?.name || user?.email || "--";

const ManageNotificationUsers = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const limit = 20;
  const { data, isLoading, isFetching, isError } = useGetNotificationManagementUsersQuery({ category, search, page, limit }, { skip: !category });
  const users = data?.records || data?.users || data?.data || (Array.isArray(data) ? data : []);
  const total = data?.total ?? data?.totalRecords ?? data?.count ?? users.length;
  const columns = [
    {
      head: "NAME",
      accessor: "firstname",
      isComponent: true,
      component: (item) => <h6 className="m-0 fw-sbold">{userName(item)}</h6>
    },
    { head: "EMAIL", accessor: "email", isComponent: true, component: (item) => <h6 className="m-0 fw-sbold">{item.email || "--"}</h6> },
    // { head: "ROLE", accessor: "role", isComponent: true, component: (item) => <h6 className="m-0 fw-sbold text-capitalize">{item.role?.name || item.role || categoryLabel(category)}</h6> },
  ];

  const handleSearch = useCallback(debounce((value) => { setSearch(value); setPage(1); }, 500), []);

  const breadcrumbItems = [
    { label: "Manage Notifications", path: MANAGE_NOTIFICATIONS },
    { label: categoryLabel(category) },
  ];

  return <section className="designations position-relative py-4">
    <Container fluid>
      <Row className="justify-content-between align-items-end" >
        <Row style={{ paddingLeft: '12px' }} className="pt-3">
          <Col lg="6">
            <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
          </Col>
        </Row>
        {/* <div className="mt-4" style={{ paddingLeft: '12px', borderRadius: "4px" }}>

          <Col lg='5'>
            <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
              Documents
            </p>
          </Col>
          <Col lg='7'>

          </Col>
        </div> */}
      </Row>
      <Row>
        <Col lg="12" className="my-3">
          <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
            <div>
              <h6 className="m-0 fw-bold main-head themeBlue">{categoryLabel(category) ? `${categoryLabel(category)} Profiles` : ""}</h6>
            </div>
            <div>
              <input className="input-new readonly-box h-auto search-input-filter-v2" placeholder="Search users..." onChange={(event) => handleSearch(event.target.value)} />
            </div>
          </div>
        </Col>
        <Col lg="12" className="my-2">
          <div className="table-outer">
            {isLoading ? <div style={{ height: "200px" }}><LoadingIndicator />
            </div> :
              isError ? <ErrorComponent /> :
                <>{isFetching && <LoadingOverlay />}
                  <TableLayoutV2
                    data={users}
                    column={columns}
                    handleRowClick={(user) => navigate(`/manage-notifications/${category}/${user.id || user.user_id}`)} />
                  <CstmPagination totalPages={Math.ceil(total / limit)} activePage={page} className="paginationV2" handlePageChange={setPage} />
                </>}
          </div>
        </Col>
      </Row>
    </Container>
  </section>;
};

export default ManageNotificationUsers;
